import logo from "./logo.svg"
import "./App.css"
import { createBrowserRouter, RouterProvider, Navigate, Outlet } from "react-router-dom"
import AppWrapper from "./components/AppWrapper"
import ReactGA from "react-ga4"
import PageTracker from "./components/common/PageTracker"
import ProviderDashboardTemplate from "./components/ProviderDashboardTemplate/ProviderDashboardTemplate"

import { Feedback } from "@mui/icons-material"
import Myaccount from "./components/Myaccount/Myaccount"
import ServiceSupport from "./components/ServiceSupport/ServiceSupport"
import { ThemeProvider } from "@mui/material"
import theme from "./Themes/Default"
import { authRoute, customerDashboard } from "./components/routesfile"
import EmailVeriFy from "./components/Auth/EmailVerify"
import ResetPasswordAuth from "./components/Auth/ResetPassword"
import AuthWrapper from "./components/Auth/AuthWrapper"
import { useAppSelector } from "./app/hooks"

import PersonalStep from "./components/PersonalInfo/PersonalStep"
import StepperLayout from "./components/PersonalInfo/StepperLayout"
import ServiceStep from "./components/PersonalInfo/ServiceStep"
import ProfileStep from "./components/PersonalInfo/ProfileStep"
import ProfileSaved from "./components/PersonalInfo/ProfileSaved"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { useGetNotificationsQuery } from "./features/Socket/notificationsApi"
import { api } from "./features/Auth/authApi"
import { useAppDispatch } from "./app/store"
import { Message, Ticket } from "./components/ChatenterFace/chatinterface"
import { useSocketChatMessageQuery } from "./features/ChatSocket/chatMessageApi"
import { _setMessage, _setTicket } from "./features/ChatAuth/chatSlice"
import { chatViewApi } from "./features/ChatAuth/chatApi"

interface NotificationProps {
  content: string
}

const GA_TRACKING_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_KEY || "G-G1GHD41BPZ"

if (GA_TRACKING_ID) {
  ReactGA.initialize(GA_TRACKING_ID)
}

const RootLayout = () => (
  <>
    <PageTracker />
    <Outlet />
  </>
)

function App() {
  const token = useAppSelector((state: any) => state.auth?.token)
  const onboardKey = useAppSelector((state) => state.auth.onboardDetails)
  const [getnotification, setGetNotification] = useState<NotificationProps[]>(
    [],
  )
  const { data: notificationData } = useGetNotificationsQuery(token, {
    refetchOnMountOrArgChange: true,
    skip: token == null,
  })
  const { data: chatMessage } = useSocketChatMessageQuery(token, {
    refetchOnMountOrArgChange: true,
    skip: token == null,
  })
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (getnotification.length && notificationData?.length) {
      const id = notificationData[0]._id

      dispatch(api.util.invalidateTags(["notifications", "activejobs"]))
      dispatch(chatViewApi.util.invalidateTags(["notifications"]))
    }
  }, [getnotification])

  useEffect(() => {
    if (notificationData) {
      setGetNotification(notificationData)
    }
  }, [notificationData])

  const router = createBrowserRouter([
    {
      path: "/",
      element: <RootLayout />,
      children: [
        {
          element: <EmailVeriFy />,
          path: "verify-email",
        },
        {
          element: <ResetPasswordAuth />,
          path: "reset-password",
        },
        {
          path: "dashboard",
          element:
            token && token ? (
              <ProviderDashboardTemplate />
            ) : (
              <Navigate to="/" replace />
            ),

          children: customerDashboard,
        },
        {
          path: "",
          element: !token ? (
            <AuthWrapper />
          ) : (
            <Navigate to="/dashboard" replace />
          ),
          children: authRoute,
        },

        {
          element: onboardKey ? <StepperLayout /> : <Navigate to="/" replace />,
          path: "provider-onboarding",
        },
      ],
    },
  ])

  return (
    <>
      <ThemeProvider theme={theme}>
        <RouterProvider router={router} />
      </ThemeProvider>
    </>
  )
}

export default App
